// extracted by mini-css-extract-plugin
export default {"formElement":"formElement__pU_y9","formContainer":"formContainer__sD3_e","formContainer_disabled":"formContainer_disabled__RoZrI"};